import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/services/cart.service';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-orders',
  templateUrl: './view-orders.component.html',
  styleUrls: ['./view-orders.component.css']
})
export class ViewOrdersComponent implements OnInit {

  public baskets = [];
  private basketsSub: Subscription;

  public leaves = [];
  private leaevsSub: Subscription;

  public dressings = [];
  private dressingsSub: Subscription;

  price: number = 0;
  private priceSub: Subscription;

  subscriptionType: string = '';

  totalCount: number = 0
  public totalCountSub: Subscription;


  constructor(private cartService: CartService, private dialog: MatDialog, private router: Router) { }

  ngOnInit() {
    // get cart details on load
    this.baskets = [];
    this.leaves = [];
    this.dressings = [];

    const onloadData = this.cartService.onLoad();

    this.baskets = onloadData.baskets || [];
    this.leaves = onloadData.leaves || [];
    this.dressings = onloadData.dressings || [];
    this.price = onloadData.price;
    this.totalCount = onloadData.totalCount;

    // subscribe to baskets subject
    this.basketsSub = this.cartService.getBasketsUpdated().subscribe(result => {
      this.baskets = result;
    });

    // subscribe to leaves subject
    this.leaevsSub = this.cartService.getLeavesUpdated().subscribe(result => {
      this.leaves = result;
    });

    // subscribe to dressings subject
    this.dressingsSub = this.cartService.getDressingsUpdated().subscribe(result => {
      this.dressings = result;
    });

    // subscribe to price subject
    this.priceSub = this.cartService.getPriceUpdated().subscribe(result => {
      this.price = result;
    });

    // subscribe to total count subject
    this.cartService.getTotalCountUpdated().subscribe(result => {
      this.totalCount = result;
    });
  }

  onRemove(Type: string) {
    this.cartService.remove(Type);
  }

  onIncrease(ID, Type) {
    this.cartService.increaseQuantity(ID, Type);
  }

  onDecrease(ID, Type) {
    this.cartService.decreaseQuantity(ID, Type);
  }

  onAddMoreItem() {
    this.dialog.closeAll();
    this.router.navigate(['/']);
  }
}
